import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getSportsListRequest, getSportsListRequestError, getSportsListRequestSuccess } from "../../slices/event-management/GetSportsListSlice";

export const GetSportsListApi = () => async (dispatch) => {

    try {
        dispatch(getSportsListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getSportsList,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getSportsListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getSportsListRequestError(_error));
            });
    } catch (error) { }
};
